<template>
  <div class="ovop-explore-province">
    <el-row :gutter="0">
      <el-col :span="7" class="block">
        <h2>{{explore.onlineCount}}</h2>
        <div>寻源商品数</div>
      </el-col>
      <el-col :span="1">
        <div class="divider"></div>
      </el-col>
      <el-col :span="7" class="block">
        <h2>{{explore.importCount}}</h2>
        <div>引入商品数</div>
      </el-col>
      <el-col :span="1">
        <div class="divider"></div>
      </el-col>
      <el-col :span="7" class="block">
        <h2>{{explore.iconicCount}}</h2>
        <div>地标性商品</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "OvopExploreProvinceDashboard",
  props: ["explore"]
};
</script>

<style lang="less" scoped>
.ovop-explore-province {
  .divider {
    width: 1px;
    margin: 20px auto;
    height: 50px;
    background: rgba(244, 244, 244, 1);
  }

  .el-row {
    padding: 20px 0;
  }

  h2 {
    font-size: 30px;
    font-weight: 500;
    font-family: "DIN Medium";
    color: rgba(27, 153, 79, 1);
    text-align: center;
  }

  .block {
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #333;

    img {
      width: 20px;

      vertical-align: top;
      margin-right: 5px;
    }
  }
}
</style>